export const getLocalProtocol = (): string => {
  const { protocol } = window.location
  return protocol === 'http:' ? 'http://' : 'https://'
}
